import { useCallback, useState, useRef, useEffect } from 'react';

const HIDE_INDICATIONTION_TIMEOUT = 2500;

const useClientSideAttachmentsModifications = () => {
  const [deletedAttachments, setDeletedAttachments] = useState<string[]>([]);
  const [uploadIndicationIds, setUploadIndicationIds] = useState<string[]>([]);
  const timersArray = useRef<NodeJS.Timeout[]>([]);

  const deleteAttachment = useCallback(
    (attachmentId: string) => {
      setDeletedAttachments((prev) => [...prev, attachmentId]);
    },
    [setDeletedAttachments],
  );

  const hideAttachmentUploadIndication = useCallback(
    (attachmentId: string) => {
      setUploadIndicationIds((prev) =>
        prev.filter((id) => id !== attachmentId),
      );
    },
    [setUploadIndicationIds],
  );

  const showUploadIndicationAttachment = useCallback(
    (attachmentId: string) => {
      setUploadIndicationIds((prev) => [...prev, attachmentId]);
      // eslint-disable-next-line better-mutation/no-mutating-methods -- timersArray.current is a shared ref; the useEffect cleanup holds a reference to this same array
      timersArray.current.push(
        setTimeout(
          () => hideAttachmentUploadIndication(attachmentId),
          HIDE_INDICATIONTION_TIMEOUT,
        ),
      );
    },
    [hideAttachmentUploadIndication],
  );

  useEffect(() => {
    const currentTimers = timersArray.current;

    return () => {
      currentTimers.forEach((timer) => clearTimeout(timer));
    };
  }, []);

  return {
    deleteAttachment,
    deletedAttachments,
    uploadIndicationIds,
    showUploadIndicationAttachment,
    hideAttachmentUploadIndication,
  };
};

export default useClientSideAttachmentsModifications;
